unit InstrumentItemType;

{

/* Properties: Specialism and Category added. */

/* Properties: SupplierName, OrderNumber and Specifics added. */

/* Initial. */

}

interface

type
  TInstrumentItemType = class
  private
    fInstrumentKey: String;
    fName: String;
    fSupplierName: String;
    fSpecialism: String;
    fCategory: String;
    fOrderNumber: String;
    fSpecifics: String;
    fActive: Boolean;
  public
    property InstrumentKey: String read fInstrumentKey;
    property Name: String read fName;
    property SupplierName: String read fSupplierName;
    property Specialism: String read fSpecialism;
    property Category: String read fCategory;
    property OrderNumber: String read fOrderNumber;
    property Specifics: String read fSpecifics;
    property Active: Boolean read fActive;
  end;

implementation

end.
